import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import { useCustomerAuth, authClient } from "@/context/CustomerAuthContext";

let cache = null;
const listeners = new Set();
const setCache = (v) => { cache = v; listeners.forEach((fn) => fn(new Set(v))); };

export function useWishlist() {
  const { user } = useCustomerAuth();
  const [ids, setIds] = useState(cache ? new Set(cache) : new Set());
  useEffect(() => {
    listeners.add(setIds);
    if (user && !cache) authClient.get("/account/wishlist").then(({ data }) => setCache((data.items || []).map((i) => i.product_id))).catch(() => {});
    if (!user) setCache([]);
    return () => listeners.delete(setIds);
  }, [user]);
  return ids;
}

export default function WishlistButton({ product, size = "", color = "", className = "", testId, onChange }) {
  const { user, login } = useCustomerAuth();
  const ids = useWishlist();
  const [busy, setBusy] = useState(false);
  const on = ids.has(product.id);

  const toggle = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (!user) { toast("Sign in to save favorites and get back-in-stock alerts", { action: { label: "Sign in", onClick: () => login(window.location.pathname + window.location.search) } }); return; }
    setBusy(true);
    try {
      if (on) { await authClient.delete(`/account/wishlist/${product.id}`); setCache([...ids].filter((i) => i !== product.id)); toast.success("Removed from your wishlist"); onChange?.(false); }
      else { await authClient.post("/account/wishlist", { product_id: product.id, size, color }); setCache([...ids, product.id]); toast.success(`Saved · we'll email you if ${size || color ? "that option" : "it"} comes back in stock`); onChange?.(true); }
    } catch { toast.error("Could not update wishlist"); }
    finally { setBusy(false); }
  };

  return (
    <button type="button" aria-pressed={on} aria-label={on ? "Remove from wishlist" : "Add to wishlist"} data-testid={testId || `wishlist-btn-${product.id}`} onClick={toggle} disabled={busy}
      className={`w-9 h-9 rounded-full grid place-items-center border-2 transition-colors ${on ? "bg-red-500 border-red-500 text-white" : "bg-white/90 border-zinc-200 text-zinc-600 hover:border-red-400 hover:text-red-500"} ${className}`}>
      <Heart className={`w-4 h-4 ${on ? "fill-current" : ""}`} />
    </button>
  );
}
